import { ICommunity } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { ErrorMessage } from "components/ui/error-message";
import { Spinner } from "components/ui/spinner";
import * as React from "react";
import { useUsers } from "store/selectors/hooks";
import { ListReferredClients } from "../../clients/list-referred-clients";
import { trpc } from "../../rpc/trpc";

interface CommunityInboundReferralsProps {
    community: ICommunity;
}

export const CommunityInboundReferrals: React.FC<
    CommunityInboundReferralsProps
> = props => {
    const { community } = props;
    const users = useUsers();
    const trpcClient = trpc.useTRPC();
    const query = useQuery({
        ...trpcClient.referralSource.listReferredClients.queryOptions({
            kind: "community",
            id: community.id,
        }),
    });

    if (query.isLoading) {
        return (
            <div className="flex justify-center py-8">
                <Spinner />
            </div>
        );
    }

    if (query.data === undefined) {
        return (
            <ErrorMessage component="CommunityInboundReferrals">
                <pre>{JSON.stringify(query.error, null, 2)}</pre>
            </ErrorMessage>
        );
    }

    if (query.data.length === 0) {
        return (
            <div>
                <h3>
                    No Inbound Client Referrals have been received from this community
                    yet.
                </h3>
                <br />
                <p>
                    Note: when editing a Client profile, if you mark any client&apos;s
                    &quot;Referral Source&quot; as this community, that client will then
                    be listed here.
                </p>
            </div>
        );
    }

    return (
        <div>
            <p>
                The table below shows all Clients referred to you (or your agency) that
                have come from this community ({community.name}).
            </p>
            <br />
            <ListReferredClients clients={query.data} users={users.users} />
        </div>
    );
};
